// ZM - Reviewed by Claude Portal-Review Deep Dive 2026-04-28
import React, { useMemo } from 'react';
import { IconRemove } from 'src/content/icons';
import { strings } from 'src/localization/index';
import { Diagnoses } from '../WriteYourOwn';
import { EventOrElement } from 'src/types';
import css from './AddedIssues.module.scss';

const THEME_HEADER_CLASSES: Record<string, string | undefined> = {
    mazda: css.headerMazda,
    genesis: css.headerGenesis,
};

interface IProps {
    // The list of diagnosed and custom issues
    issueList: Diagnoses[]
    // Removes an issue from the list
    removeIssue: (id: string, e: EventOrElement) => void
    theme: 'mazda' | 'genesis' | string
}

/** Renders the list of user-added diagnostic issues with a delete action for each. */
const AddedIssues = (props: IProps) => {
    const { issueList, removeIssue, theme } = props;

    const headerClass = THEME_HEADER_CLASSES[theme];

    const issues = useMemo(() => issueList.map((issue, index) => (
        <div key={issue.id} className={css.issue}>
            <p className={css.issueText}>{issue.diagnosis}</p>
            <IconRemove id={'deleteBtn' + index} aria-label={'Remove issue ' + (index + 1)}
                onClick={(e: React.MouseEvent<SVGSVGElement>) => removeIssue(issue.id, e)}
                className={css.icon}/>
        </div>
    )), [issueList, removeIssue]);

    return (
        <div id='addedIssues'>
            <h2 className={headerClass}>{strings.AddedIssue}</h2>
            {issues}
        </div>
    );
};

export default AddedIssues;